module.exports = __webpack_public_path__ + "img/flags/IE.a22997c.png";